import { render, staticRenderFns } from "./DialogTitle.vue?vue&type=template&id=3dd8f8b0"
import script from "./DialogTitle.vue?vue&type=script&lang=js"
export * from "./DialogTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports